import { useEffect, useState } from "react";
import { animate } from "framer-motion";

// Animates a stat tile's number counting up from 0 whenever `value`
// changes. Falls back to showing the value as-is when it isn't numeric
// (e.g. "—" while data is still loading).
export default function useCountUp(value, duration = 0.7) {
  const numeric = typeof value === "number" ? value : Number(value);
  const isNumber = value !== null && value !== undefined && value !== "" && !Number.isNaN(numeric);
  const [display, setDisplay] = useState(isNumber ? 0 : value);

  useEffect(() => {
    if (!isNumber) {
      setDisplay(value);
      return;
    }
    const controls = animate(0, numeric, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numeric, isNumber]);

  return display;
}
